/*
import axios from "axios";
axios.defaults.withCredentials = true;
export default axios
*/
import axios from "axios";

const apiClient = axios.create({
  baseURL: "", // 👈 clave para tu proxy
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

export default apiClient;